import { Search, Filter, Download, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";

const EmployeeHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white border-b border-slate-200 px-8 py-6 shadow-sm">
      <div className="flex items-center justify-between">

        {/* Left Section */}
        <div>
          <h1 className="text-5xl font-bold text-slate-900 tracking-tight">
            Employees
          </h1>

          <p className="mt-2 text-lg text-slate-500">
            Manage employee records and workforce information
          </p>
        </div>

        {/* Right Section */}
        <div className="flex items-center gap-4">

          {/* Search */}
          <div className="flex items-center h-14 w-96 px-4 bg-slate-50 border border-slate-200 rounded-xl focus-within:border-blue-500 focus-within:bg-white transition-all">
            <Search size={20} className="text-slate-400" />

            <input
              type="text"
              placeholder="Search employee..."
              className="ml-3 w-full bg-transparent outline-none text-base"
            />
          </div>

          {/* Filters */}
          <button className="flex items-center gap-2 h-14 px-6 bg-white border border-slate-200 rounded-xl hover:bg-slate-50 transition">
            <Filter size={18} />
            <span className="font-medium">Filters</span>
          </button>

          {/* Export */}
          <button className="flex items-center gap-2 h-14 px-6 bg-white border border-slate-200 rounded-xl hover:bg-slate-50 transition">
            <Download size={18} />
            <span className="font-medium">Export</span>
          </button>

          {/* Add Employee */}
          <button
  onClick={() => navigate("/hr/employee/add")}
  className="bg-blue-600 text-white px-6 py-3 rounded-lg"
>
  + Add Employee
</button>

        </div>
      </div>
    </div>
  );
};

export default EmployeeHeader;